import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("閉室予定時刻を更新")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-3/4 mx-auto mt-5 text-center text-gray-500 text-sm" }, " ※ 終了予定日、終了予定時間を削除し更新すると、終了予定時刻を未設定にすることができます。 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 更新する ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "終了予定日",
          name: "date",
          type: "date",
          placeholder: "",
          value: _ctx.date,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "終了予定時間",
          name: "time",
          type: "time",
          placeholder: "",
          value: _ctx.time,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.time = $event))
        }, null, 8, ["value"])
      ]),
      _hoisted_4
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "secondary-500",
        "hover-color": "secondary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.updateEndTimeOfRoom
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}